import { Menu, X, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { BBotLogo } from '@/components/branding';
import { Button } from '@/components/ui/Button';

interface MobileHeaderProps {
  isMenuOpen: boolean;
  onToggleMenu: () => void;
}

export function MobileHeader({ isMenuOpen, onToggleMenu }: MobileHeaderProps) {
  return (
    <div className="md:hidden fixed top-0 left-0 right-0 z-50 px-4 sm:px-6 py-3 flex justify-between items-center border-b border-slate-600/20 bg-slate-800/90 shadow-lg shadow-black/10">
      <Link to="/" className="flex items-center gap-3">
        <BBotLogo size="w-7 h-7" />
        <span className="font-bold text-xl leading-7 bg-clip-text text-transparent bg-gradient-to-r from-white to-slate-400">
          DialogMe
        </span>
      </Link>
      <div className="flex items-center gap-3">
        <a href="https://console.dialogme.ai" target="_blank" rel="noopener noreferrer">
          <Button variant="primary" size="sm" leftIcon={<ArrowRight className="w-4 h-4" />}>
            Get Access
          </Button>
        </a>
        <button
          className="text-slate-300 hover:text-white transition-colors"
          onClick={onToggleMenu}
        >
          {isMenuOpen ? <X /> : <Menu />}
        </button>
      </div>
    </div>
  );
}
